import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { FiClock } from "react-icons/fi";
import "../../assets/css/AuthOtp.css";

// IMPORT IMAGES (VERY IMPORTANT)
import bg1 from "../../assets/img/bg/bg-01.png";
import bg2 from "../../assets/img/bg/bg-02.png";
import bg3 from "../../assets/img/bg/bg-03.png";
import authImg from "../../assets/img/bg/authentication-bg-01.png";
import logo from "../../assets/img/logo-1.svg";

const OtpVerification = () => {
  return (
    <div className="main-wrapper">
      <Container fluid>
        <Row className="vh-100">

          {/* LEFT SIDE */}
   <Col lg={5} className="left-section d-none d-lg-flex">
  <div className="left-wrapper">

    {/* DECOR SHAPES */}
    <img src={bg1} className="shape shape-top" alt="" />
    <img src={bg2} className="shape shape-bottom" alt="" />
    <img src={bg3} className="shape shape-3d" alt="" />

    {/* CARD */}
    <div className="left-card">
      <h1>
        Empowering people <br />
        through seamless HR <br />
        management.
      </h1>

      <img src={authImg} className="team-img" alt="" />

      <p>
        Efficiently manage your workforce,
        streamline operations effortlessly.
      </p>
    </div>

  </div>
</Col>

          {/* RIGHT SIDE */}
          <Col lg={7} md={12} className="right-section">
            <div className="form-wrapper">

              <div className="logo text-center">
                <img src={logo} alt="logo" />
              </div>

              <div className="otp-box text-center">
                <h2>Email OTP Verification</h2>
                <p>
                  Please enter the OTP received to confirm your account ownership.
                  A code has been sent to ******[email protected]
                </p>

                {/* OTP INPUTS */}
                <div className="otp-inputs">
                  <Form.Control maxLength={1} />
                  <Form.Control maxLength={1} />
                  <Form.Control maxLength={1} />
                  <Form.Control maxLength={1} />
                </div>

                {/* TIMER */}
                <div className="timer">
                  <FiClock /> 09:59
                </div>

                {/* RESEND */}
                <p className="resend">
                  Didn't get the OTP? <span>Resend OTP</span>
                </p>

                {/* BUTTON */}
                <Button className="verify-btn">
                  Verify & Proceed
                </Button>
              </div>

              <div className="footer text-center">
                Copyright © 2026 - Smarthr
              </div>

            </div>
          </Col>

        </Row>
      </Container>
    </div>
  );
};

export default OtpVerification;